import { useOnlineStatus } from "@/shared/hooks/use-online-status";

export const OfflineBanner = () => {
  const isOnline = useOnlineStatus();

  if (isOnline) return null;

  return (
    <output
      data-testid="offline-status"
      aria-live="polite"
      className="fixed top-3 left-1/2 z-50 flex -translate-x-1/2 items-center gap-2 rounded-[var(--r-sm)] border-[1.5px] border-[var(--warning)]/50 bg-[var(--warning)]/10 px-3 py-1.5 font-mono text-[10.5px] font-semibold uppercase tracking-[0.06em] text-[var(--warning)]"
    >
      <span
        className="inline-block h-2 w-2 animate-pulse rounded-full"
        style={{ background: "var(--warning)" }}
        aria-hidden
      />
      Offline — workouts run locally
    </output>
  );
};
